import React, { useState } from 'react';
import { Welcome } from './components/Welcome';
import { ProfileSetup } from './components/ProfileSetup';
import { AssessmentsHub } from './components/AssessmentsHub';
import { CareerResults } from './components/CareerResults';
import { JourneyMap } from './components/JourneyMap';
import { Leaderboard } from './components/Leaderboard';
import { DailyChallenge } from './components/DailyChallenge';
import { AstroBot } from './components/AstroBot';
import { NavBar } from './components/shared/NavBar';
import { AdminDashboard } from './components/admin/AdminDashboard';
// New imports for the connected prototype
import { RoleSelection } from './components/RoleSelection';
import { WelcomeOnboarding } from './components/user/WelcomeOnboarding';
import { ProfileSetupWizard } from './components/user/ProfileSetupWizard';
import { InbornInputs } from './components/user/InbornInputs';
import { SelfReportedAssessments } from './components/user/SelfReportedAssessments';
import { ContextCapture } from './components/user/ContextCapture';
import { CareerGenomeCalculation } from './components/user/CareerGenomeCalculation';
import { ResultsDashboard } from './components/user/ResultsDashboard';
import { CareerJourneyMap } from './components/user/CareerJourneyMap';
import { GamificationHub } from './components/user/GamificationHub';
import { InputSystemsManager } from './components/admin/InputSystemsManager';
import { CareerGenomeMapper } from './components/admin/CareerGenomeMapper';
import { RecommendationLogicBuilder } from './components/admin/RecommendationLogicBuilder';
export function App() {
  const [currentScreen, setCurrentScreen] = useState('role-selection');
  const [showAstroBot, setShowAstroBot] = useState(false);
  const [isAdminMode, setIsAdminMode] = useState(false);
  const [adminSection, setAdminSection] = useState('dashboard');
  const renderScreen = () => {
    switch (currentScreen) {
      case 'role-selection':
        return <RoleSelection onSelectRole={role => {
          if (role === 'user') {
            setCurrentScreen('welcome-onboarding');
            setIsAdminMode(false);
          } else {
            setIsAdminMode(true);
            setCurrentScreen('admin');
          }
        }} data-id="element-0" />;
      // User flow screens
      case 'welcome-onboarding':
        return <WelcomeOnboarding onComplete={() => setCurrentScreen('profile-setup-wizard')} data-id="element-1" />;
      case 'profile-setup-wizard':
        return <ProfileSetupWizard onComplete={() => setCurrentScreen('inborn-inputs')} data-id="element-2" />;
      case 'inborn-inputs':
        return <InbornInputs onComplete={() => setCurrentScreen('self-reported')} data-id="element-3" />;
      case 'self-reported':
        return <SelfReportedAssessments onComplete={() => setCurrentScreen('context-capture')} data-id="element-4" />;
      case 'context-capture':
        return <ContextCapture onComplete={() => setCurrentScreen('career-genome-calculation')} data-id="element-5" />;
      case 'career-genome-calculation':
        return <CareerGenomeCalculation onComplete={() => setCurrentScreen('results-dashboard')} data-id="element-6" />;
      case 'results-dashboard':
        return <ResultsDashboard onContinue={() => setCurrentScreen('career-journey-map')} data-id="element-7" />;
      case 'career-journey-map':
        return <CareerJourneyMap onContinue={() => setCurrentScreen('gamification-hub')} data-id="element-8" />;
      case 'gamification-hub':
        return <GamificationHub data-id="element-9" />;
      // Legacy screens (can be removed or kept for reference)
      case 'welcome':
        return <Welcome onGetStarted={() => setCurrentScreen('profile')} data-id="element-10" />;
      case 'profile':
        return <ProfileSetup onComplete={() => setCurrentScreen('assessments')} data-id="element-11" />;
      case 'assessments':
        return <AssessmentsHub onComplete={() => setCurrentScreen('results')} data-id="element-12" />;
      case 'results':
        return <CareerResults onContinue={() => setCurrentScreen('journey')} data-id="element-13" />;
      case 'journey':
        return <JourneyMap data-id="element-14" />;
      case 'leaderboard':
        return <Leaderboard data-id="element-15" />;
      case 'challenge':
        return <DailyChallenge data-id="element-16" />;
      default:
        return <RoleSelection onSelectRole={role => {
          if (role === 'user') {
            setCurrentScreen('welcome-onboarding');
            setIsAdminMode(false);
          } else {
            setIsAdminMode(true);
            setCurrentScreen('admin');
          }
        }} data-id="element-17" />;
    }
  };
  // Toggle admin mode for demo purposes
  const toggleAdminMode = () => {
    setIsAdminMode(!isAdminMode);
    if (!isAdminMode) {
      setCurrentScreen('admin');
    } else {
      setCurrentScreen('role-selection');
    }
  };
  const renderAdminSection = () => {
    switch (adminSection) {
      case 'dashboard':
        return <DashboardOverview data-id="element-18" />;
      case 'traits':
        return <TraitLibrary data-id="element-19" />;
      case 'careers':
        return <CareerGenomeMatrix data-id="element-20" />;
      case 'input-systems':
        return <InputSystemsManager data-id="element-21" />;
      case 'career-genome-mapper':
        return <CareerGenomeMapper data-id="element-22" />;
      case 'recommendation-logic':
        return <RecommendationLogicBuilder data-id="element-23" />;
      default:
        return <DashboardOverview data-id="element-24" />;
    }
  };
  if (isAdminMode) {
    return <div className="relative" data-id="element-25">
        <div className="flex h-screen bg-gray-50" data-id="element-26">
          <AdminSidebar activeSection={adminSection} onNavigate={setAdminSection} data-id="element-27" />
          <div className="flex-1 overflow-auto" data-id="element-28">
            <header className="bg-white shadow-sm border-b border-gray-200" data-id="element-29">
              <div className="px-4 py-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-30">
                <h1 className="text-2xl font-semibold text-gray-900" data-id="element-31">
                  CareerAstro Admin
                </h1>
                <div className="flex items-center space-x-4" data-id="element-32">
                  <div className="relative" data-id="element-33">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-34">
                      <svg className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" data-id="element-35">
                        <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" data-id="element-36" />
                      </svg>
                    </span>
                    <input type="text" placeholder="Search..." className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#7D56F4] focus:border-[#7D56F4]" data-id="element-37" />
                  </div>
                  <div className="flex items-center space-x-2" data-id="element-38">
                    <div className="w-8 h-8 rounded-full bg-[#7D56F4] flex items-center justify-center text-white" data-id="element-39">
                      A
                    </div>
                    <span className="text-sm font-medium text-gray-700" data-id="element-40">
                      Admin
                    </span>
                  </div>
                </div>
              </div>
            </header>
            <main className="p-6" data-id="element-41">{renderAdminSection()}</main>
          </div>
        </div>
        <button onClick={toggleAdminMode} className="fixed bottom-4 left-4 bg-gray-800 text-white px-4 py-2 rounded-md text-sm z-50" data-id="element-42">
          Exit Admin Mode
        </button>
      </div>;
  }
  return <div className="relative w-full min-h-screen bg-gradient-to-b from-[#0A1128] to-[#1C2541] text-white overflow-hidden" data-id="element-43">
      <div className="absolute inset-0 overflow-hidden" data-id="element-44">
        <div className="absolute top-0 left-0 w-full h-full opacity-30" data-id="element-45">
          {/* Stars background */}
          {[...Array(100)].map((_, i) => <div key={i} className="absolute rounded-full bg-white" style={{
          width: Math.random() * 3 + 1 + 'px',
          height: Math.random() * 3 + 1 + 'px',
          top: Math.random() * 100 + '%',
          left: Math.random() * 100 + '%',
          opacity: Math.random() * 0.8 + 0.2,
          animation: `twinkle ${Math.random() * 5 + 5}s infinite`
        }} data-id="element-46" />)}
        </div>
      </div>
      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 py-6" data-id="element-47">
        {currentScreen !== 'role-selection' && currentScreen !== 'welcome-onboarding' && <NavBar currentScreen={currentScreen} onNavigate={setCurrentScreen} data-id="element-48" />}
        <main className="mt-6" data-id="element-49">{renderScreen()}</main>
        {currentScreen !== 'role-selection' && currentScreen !== 'welcome-onboarding' && <button onClick={() => setShowAstroBot(!showAstroBot)} className="fixed bottom-6 right-6 bg-[#7D56F4] text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg hover:bg-[#6A46E5] transition-all z-50" data-id="element-50">
              <span className="text-2xl" data-id="element-51">✨</span>
            </button>}
        {currentScreen !== 'role-selection' && <button onClick={toggleAdminMode} className="fixed bottom-4 left-4 bg-[#0A1128] border border-[#3A506B] text-white px-4 py-2 rounded-md text-sm z-50" data-id="element-52">
            {isAdminMode ? 'User Mode' : 'Admin Mode'}
          </button>}
      </div>
      {showAstroBot && <AstroBot onClose={() => setShowAstroBot(false)} data-id="element-53" />}
      <style jsx data-id="element-54">{`
        @keyframes twinkle {
          0% {
            opacity: 0.2;
          }
          50% {
            opacity: 0.8;
          }
          100% {
            opacity: 0.2;
          }
        }
      `}</style>
    </div>;
}
// Admin sidebar component for better organization
const AdminSidebar = ({
  activeSection,
  onNavigate
}) => {
  const navItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: 'LayoutDashboard'
  }, {
    id: 'traits',
    label: 'Trait Library',
    icon: 'Tags'
  }, {
    id: 'careers',
    label: 'Career Genome',
    icon: 'Briefcase'
  }, {
    id: 'input-systems',
    label: 'Input Systems',
    icon: 'ClipboardList'
  }, {
    id: 'career-genome-mapper',
    label: 'Genome Mapper',
    icon: 'GitBranch'
  }, {
    id: 'recommendation-logic',
    label: 'Recommendation Logic',
    icon: 'GitBranch'
  }, {
    id: 'users',
    label: 'User Insights',
    icon: 'Users'
  }, {
    id: 'gamification',
    label: 'Gamification',
    icon: 'Award'
  }, {
    id: 'reports',
    label: 'Reports & Analytics',
    icon: 'BarChart3'
  }];
  return <div className="w-64 bg-white border-r border-gray-200 flex flex-col h-full" data-id="element-55">
      <div className="p-6" data-id="element-56">
        <div className="flex items-center space-x-2" data-id="element-57">
          <div className="w-10 h-10 rounded-full bg-gradient-to-r from-[#7D56F4] to-[#19D3DA] flex items-center justify-center text-white text-xl" data-id="element-58">
            ✨
          </div>
          <div data-id="element-59">
            <h2 className="font-bold text-gray-900" data-id="element-60">CareerAstro</h2>
            <p className="text-xs text-gray-500" data-id="element-61">Admin Portal</p>
          </div>
        </div>
      </div>
      <nav className="mt-2 flex-1" data-id="element-62">
        <div className="px-2 space-y-1" data-id="element-63">
          {navItems.map(item => <button key={item.id} onClick={() => onNavigate(item.id)} className={`flex items-center w-full px-4 py-2.5 text-sm rounded-md transition-colors ${activeSection === item.id ? 'bg-[#7D56F4]/10 text-[#7D56F4] font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-64">
              <span className={`mr-3 ${activeSection === item.id ? 'text-[#7D56F4]' : 'text-gray-500'}`} data-id="element-65">
                {/* Icon would be rendered here in a real implementation */}
                <span className="w-5 h-5 inline-block" data-id="element-66">{item.icon[0]}</span>
              </span>
              {item.label}
            </button>)}
        </div>
      </nav>
      <div className="p-4 border-t border-gray-200" data-id="element-67">
        <div className="space-y-1" data-id="element-68">
          <button className="flex items-center w-full px-4 py-2 text-sm text-gray-700 rounded-md hover:bg-gray-100" data-id="element-69">
            <span className="mr-3 text-gray-500" data-id="element-70">
              {/* Icon would be rendered here */}
              <span className="w-5 h-5 inline-block" data-id="element-71">S</span>
            </span>
            Settings
          </button>
          <button className="flex items-center w-full px-4 py-2 text-sm text-gray-700 rounded-md hover:bg-gray-100" data-id="element-72">
            <span className="mr-3 text-gray-500" data-id="element-73">
              {/* Icon would be rendered here */}
              <span className="w-5 h-5 inline-block" data-id="element-74">L</span>
            </span>
            Logout
          </button>
        </div>
      </div>
    </div>;
};
// Import components from admin dashboard
import { DashboardOverview } from './components/admin/DashboardOverview';
import { TraitLibrary } from './components/admin/TraitLibrary';
import { CareerGenomeMatrix } from './components/admin/CareerGenomeMatrix';